import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postProjectForm = (
    backend: string,
    token: string,
    ProjectID: number,
    EmployeeID: number,
    Name: string,
    Description: string,
    ChangedByID: number,
    components?
) => {
    return fetch(
        `${getApiUrl(backend)}project_forms`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ProjectID,
                EmployeeID,
                Name,
                Description,
                ChangedByID,
                CreatedByID: ChangedByID,
                components
            })
        }
    );
};

export default postProjectForm;
